import React from 'react';
import { Chip, useTheme } from '@mui/material';
import { includes } from '@/types/typeGuards';
import { usePhrase } from '@/hooks/general';
import { Tooltip } from '@/components/forms/other/Tooltip/Tooltip';

interface StatusProps {
    statusColor: string;
    statusPhraseId: number;
    title?: number;
}

const Status = (props: StatusProps) => {
    const theme = useTheme();
    const { t } = usePhrase();

    const VALID_STATUS_COLORS = ['success', 'warning', 'danger', 'info'] as const;

    const getStatusColour = (statusColour: string, bgOrText: 'background' | 'text') =>
        includes(VALID_STATUS_COLORS, statusColour)
            ? theme.colors.other[bgOrText][statusColour === 'danger' ? 'error' : statusColour]
            : theme.colors.other.chip.default[bgOrText];

    const chipStyles = {
        cursor: props?.title ? 'pointer' : 'default',
        height: 25,
        backgroundColor: getStatusColour(props.statusColor, 'background'),
        color: getStatusColour(props.statusColor, 'text'),
        boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.06)',
        borderBottom: '1px solid rgba(0, 0 ,0, 0.06)',
    };

    return (
        <>
            {props?.title ? (
                <Tooltip title={t(props.title)} enterTouchDelay={0}>
                    <Chip sx={chipStyles} label={t(props.statusPhraseId)} />
                </Tooltip>
            ) : (
                <Chip sx={chipStyles} label={t(props.statusPhraseId)} />
            )}
        </>
    );
};

export default Status;
